const API_PLUGIN_ROUTE = "/plugins/org.graylog.plugins";
const EnterpriseApiRoutes = {
  Dashboards: {
    viewConfig: (viewId) => ({ url: `views/${viewId}` }),
    searchJob: (searchId) => ({ url: `views/search/${searchId}` }),
    searchJobResults: (searchId) => ({ url: `views/search/${searchId}/execute` })
  },
  Illuminate: {
    bundles: {
      latest: {
        searchPacksPaginated: (params) => ({
          url: `${API_PLUGIN_ROUTE}.illuminate/bundles/latest/search_packs_paginated?${params}`
        }),
        searchPacksForTagPaginated: (tag, params) => ({
          url: `${API_PLUGIN_ROUTE}.illuminate/bundles/latest/search_packs_paginated/${encodeURIComponent(tag)}?${params}`
        }),
        searchPacks: (params) => ({
          url: `${API_PLUGIN_ROUTE}.illuminate/bundles/latest/search_packs?${params}`
        }),
        enablePacks: () => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles/latest/enable_packs` }),
        disablePacks: () => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles/latest/disable_packs` }),
        summary: () => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles/latest/summary` })
      },
      previous: {
        checkPrevious: () => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles/previous` }),
        enablePrevious: () => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles/previous/enable_bundle` })
      },
      index: () => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles` }),
      one: (bundleId) => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles/${bundleId}` }),
      status: () => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles/status` }),
      upload: () => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles/upload` }),
      installStatus: () => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles/installation_status` }),
      filterOptions: () => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles/packs/filter_options` }),
      hub: {
        index: () => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles/hub` }),
        latest: () => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles/hub/latest` }),
        install: (bundleId) => ({ url: `${API_PLUGIN_ROUTE}.illuminate/bundles/hub/${bundleId}` }),
        releaseNotes: (version) => ({
          url: `${API_PLUGIN_ROUTE}.illuminate/bundles/hub/release_notes/${version}`
        })
      }
    }
  },
  License: {
    list: () => ({ url: `${API_PLUGIN_ROUTE}.license/licenses/status/paginated` }),
    active: () => ({ url: `${API_PLUGIN_ROUTE}.license/licenses/status/active` }),
    save: () => ({ url: `${API_PLUGIN_ROUTE}.license/licenses` }),
    verify: () => ({ url: `${API_PLUGIN_ROUTE}.license/licenses/verify` }),
    delete: (queryParams) => ({ url: `${API_PLUGIN_ROUTE}.license/licenses?${queryParams}` }),
    validityForSubject: (subject) => ({
      url: `${API_PLUGIN_ROUTE}.license/licenses/validity/for-subject?subject=${subject}`
    }),
    metrics: () => ({ url: `${API_PLUGIN_ROUTE}.license/licenses/metrics` }),
    drawDownRemainingTraffic: (days) => ({
      url: `${API_PLUGIN_ROUTE}.license/licenses/traffic-remaining?days=${days}`
    }),
    notifications: {
      acknowledgeUsageWarning: () => ({
        url: `${API_PLUGIN_ROUTE}.license/licenses/traffic-threshold/acknowledgement`
      })
    }
  },
  SecurityApp: {
    anomalyConfiguration: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.anomaly/detectors/config` }),
    sigmaGitRepos: (options) => ({
      url: options ? `${API_PLUGIN_ROUTE}.securityapp.sigma/sigma/repositories/?${options}` : `${API_PLUGIN_ROUTE}.securityapp.sigma/sigma/repositories/`
    }),
    sigmaGitRepo: (repoId, path = "", query = "") => {
      const route = `${API_PLUGIN_ROUTE}.securityapp.sigma/sigma/repositories/${repoId}`;
      const params = [];
      if (path) params.push(`path=${path}`);
      if (query) params.push(`query=${query}`);
      return { url: params.length > 0 ? `${route}?${encodeURI(params.join("&"))}` : route };
    },
    allSigmaRepos: (options) => ({
      url: `${API_PLUGIN_ROUTE}.securityapp.sigma/sigma/repositories?${options}`
    }),
    bulkDeleteSigmaRepos: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.sigma/sigma/repositories/bulk/delete/` }),
    defaultSigmaRepo: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.sigma/sigma/repositories/default` }),
    importAllRules: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.sigma/sigma/repositories/import_all` }),
    refreshRepoRules: (id) => ({
      url: `${API_PLUGIN_ROUTE}.securityapp.sigma/sigma/repositories/refresh/${id}`
    }),
    sigmaImportBulkFromRepo: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.sigma/sigma/import/bulk/import` }),
    sigmaImportBulkUpload: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.sigma/sigma/import/bulk/upload` }),
    validateSigmaRuleZip: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.sigma/sigma/import/validate_zip` }),
    validateSigmaRuleYaml: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.sigma/sigma/import/validate` }),
    Investigations: {
      index: (params) => ({ url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations?${params}` }),
      aiAgentTriage: (invId) => ({
        url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/${invId}/ai-agent-triage`
      }),
      filters: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/filter_options` }),
      update: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations` }),
      archive: (invId, archive) => ({
        url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/archive/${invId}/${archive}`
      }),
      bulkArchive: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/archive` }),
      new: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations` }),
      priorities: {
        index: () => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/priorities?page=1&per_page=10000&sort=text&direction=asc`
        }),
        add: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/priorities` }),
        reprioritize: () => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/priorities/reprioritize`
        }),
        update: (priorityId) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/priorities/${priorityId}`
        }),
        delete: (priorityId) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/priorities/${priorityId}`
        }),
        setDefault: (priorityId) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/priorities/${priorityId}/default`
        }),
        removeDefault: () => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/priorities/default`
        })
      },
      statuses: {
        index: () => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/statuses?page=1&per_page=10000&sort=status&direction=asc`
        }),
        add: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/statuses` }),
        update: (statusId) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/statuses/${statusId}`
        }),
        delete: (statusId) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/statuses/${statusId}`
        }),
        setDefault: (statusId) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/statuses/${statusId}/default`
        }),
        removeDefault: () => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/statuses/default`
        })
      },
      AIReport: {
        quotaStatus: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/summary/quota` })
      },
      singleInvestigation: (invId, params) => ({
        url: params ? `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/${invId}?${params}` : `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/${invId}`
      }),
      paginatedInvestigationSecurityEvents: (invId, params) => ({
        url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/${invId}/security_events/paginated?${params}`
      }),
      paginatedInvestigationLogs: (invId, params) => ({
        url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/${invId}/logs/paginated?${params}`
      }),
      bulkDelete: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/bulk/delete` }),
      addEvidenceToInvestigation: (invId) => ({
        url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/evidence/${invId}`
      }),
      bulkAddEvidenceToInvestigation: () => ({
        url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/bulk/evidence/add`
      }),
      removeEvidenceFromInvestigation: (invId) => ({
        url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/evidence/remove/${invId}`
      }),
      addNoteToInvestigation: (invId) => ({
        url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/${invId}/notes`
      }),
      editInvestigationNote: (invId, noteId) => ({
        url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/${invId}/notes/${noteId}`
      }),
      deleteInvestigationNote: (invId, noteId) => ({
        url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/${invId}/notes/${noteId}`
      }),
      fetchUsers: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/users` }),
      fetchTeams: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/teams` }),
      fetchConfig: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/config` }),
      enableNotifications: (enabled) => ({
        url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/config/notifications/${enabled}`
      }),
      Procedures: {
        index: (invId, params) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/${invId}/procedures?${params}`
        }),
        titles: (invId, procedureId, params) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/${invId}/procedures/${procedureId}?${params}`
        }),
        steps: {
          events: (invId, procedureId, stepId, params) => ({
            url: `${API_PLUGIN_ROUTE}.securityapp.investigations/investigations/${invId}/procedures/${procedureId}/steps/${stepId}/events?${params}`
          })
        }
      }
    },
    Teams: {
      index: () => ({ url: `${API_PLUGIN_ROUTE}.security/teams?page=1&per_page=10000` })
    },
    Assets: {
      index: (params) => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets?${params}` }),
      assetLabels: (params) => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/names?${params}` }),
      filters: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/filter_options` }),
      eventPreview: (params) => ({
        url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/event_preview?${params}`
      }),
      singleAsset: (assetId) => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/${assetId}` }),
      assetByIds: () => ({
        url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/byIds`
      }),
      new: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets` }),
      bulkAddCategories: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/bulk/categories_add` }),
      priorities: {
        index: () => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/priorities?page=1&per_page=10000&direction=desc`
        }),
        add: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/priorities` }),
        reprioritize: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/priorities/reprioritize` }),
        update: (priorityId) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/priorities/${priorityId}`
        }),
        delete: (priorityId) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/priorities/${priorityId}`
        })
      },
      categories: {
        index: () => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/categories?page=1&per_page=10000&sort=status&direction=asc`
        }),
        add: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/categories` }),
        update: (categoryId) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/categories/${categoryId}`
        }),
        delete: (categoryId) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/categories/${categoryId}`
        })
      },
      sources: {
        index: (params) => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources?${params}` }),
        new: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources` }),
        details: (sourceId) => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/${sourceId}` }),
        update: (sourceId) => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/${sourceId}` }),
        delete: (sourceId) => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/${sourceId}` }),
        testNew: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/test` }),
        testSaved: (sourceId) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/${sourceId}/test`
        }),
        bulkTest: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/bulk/test` }),
        ms365DeploymentTypes: () => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/ms365-deployment-types`
        }),
        mappings: {
          index: (sourceId, params) => ({
            url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/${sourceId}/import-backends?${params}`
          }),
          new: (sourceId) => ({
            url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/${sourceId}/import-backends`
          }),
          details: (sourceId, mappingId) => ({
            url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/${sourceId}/import-backends/${mappingId}`
          }),
          update: (sourceId, mappingId) => ({
            url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/${sourceId}/import-backends/${mappingId}`
          }),
          delete: (sourceId, mappingId) => ({
            url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/${sourceId}/import-backends/${mappingId}`
          }),
          testNew: (sourceId, mappingId) => ({
            url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/${sourceId}/import-backends/use/${mappingId}/test`
          }),
          testSaved: (sourceId, mappingId) => ({
            url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/${sourceId}/import-backends/use/${mappingId}/test`
          }),
          import: (sourceId, mappingId) => ({
            url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/${sourceId}/import-backends/use/${mappingId}/import`
          }),
          toggleSync: (sourceId, mappingId) => ({
            url: `${API_PLUGIN_ROUTE}.securityapp.asset/assets/sources/${sourceId}/import-backends/${mappingId}/schedule`
          })
        }
      },
      scanners: {
        index: (params) => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/vulnerability_scanners?${params}` }),
        details: (id) => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/vulnerability_scanners/${id}` }),
        new: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/vulnerability_scanners` }),
        delete: (scannerId) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.asset/vulnerability_scanners/${scannerId}`
        }),
        edit: (id) => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/vulnerability_scanners/${id}` }),
        testNewScannerConnection: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/vulnerability_scanners/test` }),
        testScannerConnection: (id) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.asset/vulnerability_scanners/${id}/test`
        }),
        import: (id) => ({ url: `${API_PLUGIN_ROUTE}.securityapp.asset/vulnerability_scanners/${id}/import` }),
        schedule: (id) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp.asset/vulnerability_scanners/${id}/schedule`
        })
      }
    },
    EventProcedures: {
      index: (params) => ({ url: `${API_PLUGIN_ROUTE}.securityapp/event_procedures?${params}` }),
      new: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp/event_procedures` }),
      singleEventProcedure: (id) => ({ url: `${API_PLUGIN_ROUTE}.securityapp/event_procedures/${id}` }),
      decoratedEventProcedure: (id, event_id) => ({
        url: `${API_PLUGIN_ROUTE}.securityapp/event_procedures/${id}/${event_id}`
      }),
      steps: {
        index: (params) => ({ url: `${API_PLUGIN_ROUTE}.securityapp/event_procedures/steps?${params}` }),
        new: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp/event_procedures/steps` }),
        singleEventProcedureStep: (id) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/event_procedures/steps/${id}`
        }),
        viewParameter: (id, type) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/event_procedures/view_parameters/${id}/${type}`
        }),
        linkedProcedures: (id) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/event_procedures/procedures_with_step/${id}`
        }),
        executeAction: (params) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/event_procedure_actions?${params}`
        }),
        executeActionBulk: () => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/event_procedure_actions/bulk`
        })
      }
    }
  },
  Welcome: {
    failures: {
      processingOverview: () => ({ url: `${API_PLUGIN_ROUTE}.failure/failures/count` })
    }
  },
  ContentUI: {
    eventTypeCategory: () => ({ url: `${API_PLUGIN_ROUTE}.contentui/event_type_category/ui_mapping` }),
    externalValueActions: () => ({ url: `${API_PLUGIN_ROUTE}.contentui/external_actions/ui_mapping` })
  },
  SecurityEvents: {
    details: (eventId) => ({ url: `${API_PLUGIN_ROUTE}.securityapp/security_events/${eventId}` }),
    detailsByIds: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp/security_events/byIds` }),
    index: (params) => ({ url: `${API_PLUGIN_ROUTE}.securityapp/security_events?${params}` }),
    new: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp/security_events` }),
    singleEvent: (eventId) => ({ url: `${API_PLUGIN_ROUTE}.securityapp/security_events/${eventId}` }),
    users: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp/security_events/users` }),
    teams: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp/security_events/teams` }),
    notifications: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp/security_events/notifications` }),
    filters: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp/security_events/filter_options` }),
    investigation_status: () => ({ url: `${API_PLUGIN_ROUTE}.securityapp/security_events/status/investigation` }),
    definitions: {
      index: (params) => ({ url: `events/definitions/paginated?${params}` }),
      details: (eventDefinitionId) => ({ url: `events/definitions/${eventDefinitionId}` }),
      detailsByIds: () => ({ url: "events/definitions/byIds" }),
      types: () => ({ url: "events/entity_types" }),
      schedule: (id) => ({ url: `events/definitions/${id}/schedule` }),
      unschedule: (id) => ({ url: `events/definitions/${id}/unschedule` }),
      duplicate: (id) => ({ url: `events/definitions/${id}/duplicate` }),
      clearQueue: (id) => ({ url: `events/definitions/${id}/clear-notification-queue` }),
      bulkSchedule: () => ({ url: "events/definitions/bulk_schedule" }),
      bulkUnschedule: () => ({ url: "events/definitions/bulk_unschedule" }),
      bulkDelete: () => ({ url: "events/definitions/bulk_delete" }),
      DetectionChains: {
        list: (params) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/detection_chains?${params}`
        }),
        get: (name) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/detection_chains/${name}`
        }),
        summary: (eventId) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/detection_chains/summary_for_event/${eventId}`
        }),
        events: (name) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/detection_chains/events_for_chain/${name}`
        }),
        enable: (name) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/detection_chains/${name}/enable`
        }),
        disable: (name) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/detection_chains/${name}/disable`
        }),
        create: () => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/detection_chains`
        }),
        update: (id) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/detection_chains/${id}`
        }),
        del: (id) => ({
          url: `${API_PLUGIN_ROUTE}.securityapp/detection_chains/${id}`
        })
      }
    },
    securityNotifications: {
      index: (params) => ({ url: `events/notifications/paginated?${params}` }),
      new: () => ({ url: "events/notifications" }),
      details: (id) => ({ url: `events/notifications/${id}` }),
      test: (id) => ({ url: `events/notifications/${id}/test` })
    }
  },
  DataTiering: {
    deleteFailedSnapshot: (indexSetId) => ({
      url: `${API_PLUGIN_ROUTE}.datatiering/datatiering/repositories/index_set/${indexSetId}/failed_snapshot`
    })
  }
};
export default EnterpriseApiRoutes;
